export default __webpack_public_path__ + "static/media/face.af287928.png";